import React from 'react';

import { Link, NavLink } from 'react-router-dom';
import  cloneDeep from 'lodash/cloneDeep';
import SpanSubTitle from '../TextModifiers/SpanSubTitle';
import ModuleItemContainer from './ModuleItemContainer';
import ModuleIcon from './ModuleIcon';
import ModuleSpan from './ModuleSpan';
import StyledFlexDirection from '../StyledFlexDirection';

/*

Props:

• titleText
• data
• style
• faIconZ2
• faIcon
• iconSize

*/

// const _stringModifier = (props) => {
//     let modifiedTitle = props.mainTitleText;
    
//     if(props.mainTitleText){
//         if (props.mainTitleTextAlt) {
//             modifiedTitle = props.mainTitleText + ' | ';
//         }
//     } else {
//         modifiedTitle = '';
//     }

//     return modifiedTitle;
// }

export const ModuleList = (props) => {
    
    // const mainTitleText = _stringModifier(props);

    // const styles = {...componentStyles, ..._applyStyleModifiers(props)}
    // TODO: Convert string into array of paragraphs using const myArray = props.bodyText.split('\n') then loop over array adding div for each with required spacing
    return (
        <div id={'ModuleList'} style={{display: 'flex', flexDirection: 'column', ...props.styles }}>
            { props.titleText && 
                <SpanSubTitle id={'styles.title'} styles={{ paddingBottom: 10 }}>
                    { props.titleText }
                </SpanSubTitle>
            }
                {props.serviceModules.map((module, i) => (
                    <ModuleItemContainer moduleOrder={module.moduleOrder} key={i} id={'styles.itemContainer'}>
                        <ModuleIcon 
                            src={ module.bulletImageURL }
                            id={'styles.iconStyle'}
                            height={ props.height ? props.height : false}
                            >
                        </ModuleIcon>
                        { !!props.description &&
                            <StyledFlexDirection>
                                <ModuleSpan styles={{paddingBottom: 10}} colorPrimary >{module.moduleInstanceDescription}</ModuleSpan>
                                <ModuleSpan>
                                    {module.description}
                                </ModuleSpan> 
                            </StyledFlexDirection>
                        }
                    </ModuleItemContainer>
                ))}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/js/components/ModuleList/ModuleList.jsx